import { render, staticRenderFns } from "./DocumentsCapture.vue?vue&type=template&id=18e9a800&scoped=true"
import script from "./DocumentsCapture.vue?vue&type=script&lang=js"
export * from "./DocumentsCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e9a800",
  null
  
)

export default component.exports